import { WarrantListItem } from '@finance-lab/utils/types'
import { IssueEntity } from '../../../../types/IssueEntity'

export const getSectorIdFromIssueOrWarrant = ({ sectorLevel1, sectorLevel2 }: IssueEntity | WarrantListItem) => {
    return `${sectorLevel1}__${sectorLevel2}`
}

export const getSectorLevelsFromId = (sectorId: string) => sectorId.split('__') as [string, string?]
